









































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { DistributorsClient, RankHistoryModel } from "@/diamond-support-api";
import moment from "moment";

@Component
export default class AssociatePersonalEnrollments extends Vue {
  distributorApi = new DistributorsClient();
  rankHistory: RankHistoryModel[] = [];

  shown = true;

  drawer = null;
  search = "";
  loading = false;

  headers: any[] = [
    {
      text: "Rank",
      align: "start",
      sortable: true,
      value: "rankNumber",
    },
    {
      text: "Rank Name",
      value: "rankName",
    },
    {
      text: "Rank Date",
      value: "rankDate",
    },
  ];

  async mounted() {
    this.loading = true;
    this.rankHistory = await this.distributorApi.getRankHistory(
      this.$route.params.id
    );
    this.rankHistory.map(
      (r) => (r.rankDate = moment(new Date(r.rankDate!)).format("YYYY/MM/DD"))
    );

    this.loading = false;
  }

  @Watch("shown")
  onShownChanged() {
    if (!this.shown)
      this.$router.push(`/associates/${this.$route.params.id}/detail`);
  }
}
